module.exports = [{
      plugin: require('/Users/jackqiao/Documents/htdoc/gramara-com/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-52772108-13","head":true},
    },{
      plugin: require('/Users/jackqiao/Documents/htdoc/gramara-com/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Gramara - Write fluent English in a snap!","short_name":"Gramara","start_url":"/","background_color":"#334cff","theme_color":"#334cff","display":"minimal-ui","icon":"src/images/icon.png"},
    },{
      plugin: require('/Users/jackqiao/Documents/htdoc/gramara-com/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
